<template>
  <div class="checkin-container">
    <div class="success-box">
      <!-- ✅ Lottie Animation -->
      <lottie-player
        :animation-data="tickAnimation"
        :loop="false"
        width="150px"
        height="150px"
      />

      <h1 class="success-title">
        Check-in Successful
      </h1>
      <h2 class="success-subtitle">
        You're now checked in
      </h2>

      <p class="timer-text">
        <span
          class="time-value"
        >Timer: &nbsp; <check-in-clock
          ref="checkinClock"
        /></span>
      </p>

      <v-btn
        color="#000"
        elevation="2"
        @click="goToHome()"
      >
        Go to Home
      </v-btn>

      <!-- <centre-spinner :loading="loading" /> -->
    </div>
  </div>
</template>

<script>
// import spinner from 'src/views/components/SpinnerCentre';
import LottiePlayer from '../../Components/LottiePlayer.vue';
import tickAnimation from '../../../../assets/success.json';
import CheckInClock from '../../Components/CheckInClock.vue';

export default {
  name: 'CheckInSuccessPage',
  components: {
    // 'centre-spinner': spinner,
    'check-in-clock': CheckInClock,
    LottiePlayer,
  },
  data () {
    return {
      loading: false,
      hours: null,
      minutes: null,
      seconds: null,
      checkInTime: null,
      tickAnimation,
    };
  },
  computed: {
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    workLogs () {
      const logs = this.$store.getters['swiftuser/getWorkLogs'];
      return logs;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.fetchWorkLogsList();
    await this.fetchActiveCheckInDetails();
    setTimeout(() => {
      localStorage.removeItem('breakTime');
      this.loading = false;
    }, 2000);
  },
  methods: {
    // async setClock() {
    //   const checkInTime = localStorage.getItem("checkInTime");
    //   let checkInTimeDB = await getItem("checkInTime");
    //   const startTime = checkInTime ? JSON.parse(checkInTime) : +new Date();
    //   if (!checkInTime) localStorage.setItem("checkInTime", startTime);
    //   if (!checkInTimeDB) {
    //     checkInTimeDB = +new Date();
    //     await setItem("checkInTime", checkInTimeDB);
    //   }

    //   this.checkInTime = new Date(startTime).toISOString();
    //   this.$store.dispatch("swiftuser/updateWorkTimer");
    //   setInterval(this.StartClock, 1000);
    // },
    // async StartClock() {
    //   const checkInTime = JSON.parse(localStorage.getItem("checkInTime"));
    //   const now = +new Date();
    //   const diff = now - checkInTime;
    //   const checkInTimeDB = await getItem("checkInTime");
    //   if (!checkInTimeDB) return;

    //   this.hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(
    //     2,
    //     "0"
    //   );
    //   this.minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
    //     2,
    //     "0"
    //   );
    //   this.seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
    // },
    goToHome () {
      this.$router.push({ name: 'HomePage' });
    },
    async fetchWorkLogsList () {
      this.loading = true;
      await this.$store.dispatch('swiftuser/fetchWorkLogs', {
        externalId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    async fetchActiveCheckInDetails () {
      await this.$store
        .dispatch('swiftuser/fetchUsersCurrentCheckInDetails')
        .then((response) => {
          if (Object.keys(this.activeCheckInDetails).length > 0) {
            const checkInId = this.activeCheckInDetails.id;
            var checkInTime;
            if (
              this.workLogs.length !== 0 &&
              this.workLogs[0].timesheets &&
              this.workLogs[0].timesheets.start_time
            ) {
              checkInTime = +new Date(this.workLogs[0].timesheets.start_time);
            } else {
              checkInTime = +new Date(this.activeCheckInDetails.checkin_time);
            }
            if (
              this.activeCheckInDetails.checkin_method_type !== 'cost-shift'
            ) {
              localStorage.setItem('checkIn', checkInId);
              localStorage.setItem('checkInTime', checkInTime);
              if (this.$refs.checkinClock) {
                this.$refs.checkinClock.setClock();
              }
            }
            this.loading = false;
          } else {
            localStorage.removeItem('checkInTime');
            localStorage.removeItem('checkIn');
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.checkin-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #ffffff;
}

.success-box {
  background: white;
  border-radius: 20px;
  text-align: center;
  /* box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1); */
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.success-title {
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
  color: #2e7d32;
}

.success-subtitle {
  font-size: 18px;
  color: #555;
  margin-bottom: 20px;
}

.timer-text {
  margin: 15px 0;
  font-size: 16px;
  color: #333;
}

.label {
  font-weight: bold;
  margin-right: 5px;
}

.time-value {
  font-family: monospace;
  display: flex;
  color: #d84315;
}

.home-btn {
  margin-top: 20px;
  width: 100%;
}
</style>
